import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { DmsTaskBase } from './DmsTaskBase';
import { IDmsTaskParams } from 'apps/idl/src/model/backgroundTask';
import { TaskDescriptor } from 'apps/idl/src/services/security/backgroundTask';
import { ENetworkFlag } from 'apps/idl/src/model';

export class DeleteDmsFileTask<T extends IDmsTaskParams> extends DmsTaskBase<T> {

	//#region METHODS

	constructor(poDescriptor: TaskDescriptor<T>) {
		super(poDescriptor);
	}

	/** @override */
	public execTask(): Observable<Array<string>> {
		return this.msvcFlag.waitForFlag(ENetworkFlag.isOnlineReliable, true)
			.pipe(mergeMap(_ => this.msvcSyncDms.execPendingDelete(this.descriptor.params.fileGuid)));
	}

	//#endregion
}